import { render, staticRenderFns } from "./MonthlyZAKATCIMB.vue?vue&type=template&id=ab52550e"
import script from "./MonthlyZAKATCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlyZAKATCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports